import React from 'react';
import style from './sharing.module.scss';
import classNames from 'classnames';

interface EmailHistoryDisplayProps {
    emails: string[];
    textFilter: string;
    tagFilter: string[];
    visible: boolean;
    clickHandler: (email: string) => void;
}

export class EmailHistoryDisplay extends React.Component<EmailHistoryDisplayProps> {
    render(): JSX.Element {
        const emails = this.props.emails
            .filter(email => email.startsWith(this.props.textFilter.toLowerCase()))
            .filter(email => !this.props.tagFilter.some(tag => tag === email))
            .sort();

        const visible = emails.length > 0 ? this.props.visible : false;
        return (
            <div className={classNames(style.EmailHistory, {[style.Hidden]: !visible})}>
                {emails.map((email, index) => (
                    <div className={style.EmailLine} onClick={() => this.props.clickHandler(email)} key={index}>{email}</div>
                ))}
            </div>
        );
    }
}
